import { Divider, Stack } from '@mui/material';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import { useGetTransactionQuery } from 'api/payments/payments';
import IncDrawer, {
  IncDrawerType,
} from 'components/drawers/inc-drawer/inc-drawer.component';
import UtilityDrawerBody from 'components/drawers/utility-drawer/utility-drawer-body/utility-drawer-body.component';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import OrderDetails from '../order-details/order-details.component';
import OrderTotalInfo from '../order-total-info/order-total-info.component';
import ButtonsSection from './buttons-section/buttons-sections.conponent';
import PaymentDetailsSection from './details-section/payment-details-section/payment-details-section.component';
import PaymentMethodSection from './details-section/payment-method-section/payment-method-section.component';
import PaymentOverview from './details-section/payment-overview/payment-overview.component';
import PayAmountStatus from './pay-amount-status-section/pay-amount-status.component';
import TimelineSection from './timeline-section/timeline-section.component';

export type PaymentDetailsDrawerDataType = string;

type PaymentDetailsDetailsDrawerProps =
  IncDrawerType<PaymentDetailsDrawerDataType>;

const PaymentDetailsDrawer = ({
  isOpen,
  data: drawerData,
  ...drawerRest
}: PaymentDetailsDetailsDrawerProps) => {
  const { t } = useTranslation();
  const { data, isFetching, refetch } = useGetTransactionQuery(
    drawerData ?? skipToken,
  );
  const { items, orderTotal, chargeAmount, currency, type } = data ?? {};

  useEffect(() => {
    if (isOpen) refetch();
  }, [isOpen, refetch]);

  return (
    <IncDrawer
      {...drawerRest}
      isOpen={isOpen}
      data={drawerData}
      title={<strong>{t('drawer.transactionDrawer.title')}</strong>}
      isLoading={isFetching}
      data-testid="PaymentDetailsDrawer.Drawer"
    >
      <UtilityDrawerBody>
        <Stack divider={<Divider />} spacing={2}>
          <PayAmountStatus transaction={data} />

          <PaymentOverview transaction={data} />

          <TimelineSection transaction={data} />

          {type === 'ORDER' && (
            <OrderDetails items={items} currency={currency} />
          )}

          <OrderTotalInfo
            orderTotal={orderTotal}
            chargeAmount={chargeAmount}
            currency={currency}
          />

          <PaymentDetailsSection transaction={data} />

          <PaymentMethodSection transaction={data} />
        </Stack>
      </UtilityDrawerBody>
      <ButtonsSection transaction={data} />
    </IncDrawer>
  );
};

export default PaymentDetailsDrawer;
